import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const backgroundColor = [
  "rgba(255, 99, 132, 0.2)",
  "rgba(54, 162, 235, 0.2)",
  "rgba(255, 206, 86, 0.2)",
  "rgba(75, 192, 192, 0.2)",
  "rgba(153, 102, 255, 0.2)",
  "rgba(255, 159, 64, 0.2)",
];
const borderColor = [
  "rgba(255, 99, 132, 1)",
  "rgba(54, 162, 235, 1)",
  "rgba(255, 206, 86, 1)",
  "rgba(75, 192, 192, 1)",
  "rgba(153, 102, 255, 1)",
  "rgba(255, 159, 64, 1)",
];

export function ChartDoughnut({ data: src }) {
  if (!src || src.length === 0) return null;
  const labels = src.map((d) => d.title);
  const datasets = [{
    label: 'Total: ',
    data: src.map(s => {
      return s.dashboard_data?.map(d => d.total).reduce((acc, cur) => acc + cur, 0) ?? 0
    }),
    borderWidth: 1,
    borderColor,
    backgroundColor
  }];
  return <Doughnut data={{ labels, datasets }} />;
}
